define(
    'viewmodels/secured/help/guided/setAccessControl',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '5',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target

            if (vm.descriptions().length == 0) {
                vm.descriptions.push("fileplan lets you control the Libraries each user can access, and the functions they can perform. ");
                vm.descriptions.push("Access Control is set at the Library level, but you can also control access on individual List items (for example a particular project) or even a specific folder. ");
                vm.descriptions.push("Start by planning your Library Access Control. Individual settings can be adjusted at any time. ");
            }
            if (vm.todos().length == 0) {
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Setting Access Control | http://www.fileplan.com/access-control-video | _blank} video.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {Access Control | http://help.fileplan.com/hc/en-us/articles/203335570-What-is-Access-Control- | _blank} article.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {User Roles | http://help.fileplan.com/hc/en-us/articles/203110414-User-Roles | _blank} article to learn about the different levels of access available in fileplan.') });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: false, html: textParser.toHtml('On the {Libraries page | #libraries | _blank} select each Library in turn then use the Access Control button.') });
            }
            vm.tip(textParser.toHtml('Hover over the <i id="role-help-text" class="fa fa-question-circle"></i> icon on the Access Control screen for summary definitions.'));
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
